export enum DiffOp {
  Delete = -1,
  Equal = 0,
  Insert = 1
}
